// firebase.ts
console.log("🔍 firebase.ts loaded");

// Let TypeScript know about the global `firebase` object from the CDN scripts
declare const firebase: any;

// Your Firebase web-app config
const firebaseConfig = {
  apiKey:            "AIzaSyAwZhbK9diLg737M4VpcCsoCuuby9u5Rj8",
  authDomain:        "tad-ai-dash.firebaseapp.com",
  projectId:         "tad-ai-dash",
  storageBucket:     "tad-ai-dash.firebasestorage.app",
  messagingSenderId: "350768188005",
  appId:             "1:350768188005:web:783e90b5fecfc6181f948c",
  measurementId:     "G-R5516MMNZ2"
};

// Initialize Firebase
let app;
if (!firebase.apps.length) {
  app = firebase.initializeApp(firebaseConfig);
} else {
  app = firebase.app(); // if already initialized, use that one
}
console.log("✅ initializeApp OK — app.name =", app.name);

// Initialize services
const auth = firebase.auth();
const db = firebase.firestore();
try {
  firebase.analytics(); // Initialize for automatic page views
  console.log("✅ Analytics Initialized");
} catch (e) {
  console.warn("Analytics not supported/initialized.", e);
}

console.log("✅ Auth & Firestore services retrieved");
export { auth, db };

// Re-export helpers and types from the global namespace for v8-compat syntax
export const GoogleAuthProvider = firebase.auth.GoogleAuthProvider;
export const OAuthProvider = firebase.auth.OAuthProvider;
export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp;

// We no longer need to export the v9 modular functions as we will refactor the components
// to use the v8 syntax (e.g., auth.signOut() instead of signOut(auth)).

// Types can still be defined loosely for component props.
export type User = any; 
export type FirebaseError = any;
export type FieldValue = any;

// App-specific types remain the same
export interface UserProfileData {
  displayName: string | null;
  email:       string | null;
  phoneNumber?: string | null;
  scar?:       boolean;
  admin?:      boolean;
  createdAt?:  FieldValue;
}
export interface CurrentUser {
  auth:    User;
  profile: UserProfileData;
}

console.log("✅ firebase.ts execution complete");
